const translations = {
  en: {
    welcome: {
      title: 'Welcome to Evenly Respond',
      subtitle: "Let's set up your first conversational AI form in just a few steps. Your users will fill out forms through natural dialogue — zero UI needed.",
      cta: "Let's Go",
    },
    createQR: {
      title: 'Create Your First QR Code',
      subtitle: 'Paste a link to your Google Form, Microsoft Form, or Typeform — or connect your account to pick one.',
      orManual: 'or enter manually',
      titleLabel: 'Form Title',
      titlePlaceholder: 'e.g. Customer Feedback',
      urlLabel: 'Form URL',
      urlPlaceholder: 'https://docs.google.com/forms/...',
      urlHelp: 'Supports Google Forms, Microsoft Forms, and Typeform',
      cta: 'Create & Continue',
      required: 'Title and Form URL are required',
      success: 'QR Code created!',
    },
    customize: {
      title: 'Customize AI Voice',
      subtitle: 'Choose a voice personality and set an optional welcome message for your users.',
      welcomeLabel: 'Welcome Message (optional)',
      welcomePlaceholder: "Welcome! I'll help you fill out this form...",
      cta: 'Save & Continue',
      skip: 'Skip',
      success: 'Customization saved!',
    },
    webhook: {
      title: 'Webhook Notifications',
      subtitle: "Get notified in real-time when someone completes your form. We'll POST a JSON payload to your URL.",
      urlLabel: 'Webhook URL (optional)',
      urlPlaceholder: 'https://your-server.com/webhook',
      cta: 'Save & Continue',
      ctaEmpty: 'Continue',
      skip: 'Skip',
      success: 'Webhook configured!',
    },
    autoRetry: {
      title: 'Scheduled Auto-Retry',
      subtitle: 'If a form submission fails to reach the external platform, auto-retry will keep trying every minute until it succeeds.',
      enable: 'Enable',
      enableDesc: 'Recommended',
      disable: 'Disable',
      disableDesc: 'Manual retry only',
      cta: 'Save & Finish',
    },
    done: {
      title: "You're All Set!",
      subtitle: 'Your conversational AI form is ready. Share the QR code or unique URL with your audience.',
      dashboard: 'Go to Dashboard',
      qrCodes: 'Manage QR Codes',
    },
    steps: ['Welcome', 'Create QR', 'Customize', 'Webhooks', 'Auto-Retry', 'Done'],
    back: 'Back',
  },
  el: {
    welcome: {
      title: 'Καλωσήρθατε στο Evenly Respond',
      subtitle: 'Ας ρυθμίσουμε τη πρώτη σας φόρμα AI σε λίγα βήματα. Οι χρήστες σας θα συμπληρώνουν φόρμες μέσω φυσικού διαλόγου — χωρίς UI.',
      cta: 'Ξεκινάμε',
    },
    createQR: {
      title: 'Δημιουργήστε το Πρώτο QR Code',
      subtitle: 'Επικολλήστε ένα link από Google Form, Microsoft Form ή Typeform — ή συνδέστε τον λογαριασμό σας.',
      orManual: 'ή εισάγετε χειροκίνητα',
      titleLabel: 'Τίτλος Φόρμας',
      titlePlaceholder: 'π.χ. Σχόλια Πελατών',
      urlLabel: 'URL Φόρμας',
      urlPlaceholder: 'https://docs.google.com/forms/...',
      urlHelp: 'Υποστηρίζει Google Forms, Microsoft Forms και Typeform',
      cta: 'Δημιουργία & Συνέχεια',
      required: 'Ο τίτλος και το URL είναι υποχρεωτικά',
      success: 'Το QR Code δημιουργήθηκε!',
    },
    customize: {
      title: 'Προσαρμογή Φωνής AI',
      subtitle: 'Επιλέξτε μια φωνητική προσωπικότητα και ορίστε ένα προαιρετικό μήνυμα καλωσορίσματος.',
      welcomeLabel: 'Μήνυμα Καλωσορίσματος (προαιρετικό)',
      welcomePlaceholder: 'Καλωσήρθατε! Θα σας βοηθήσω να συμπληρώσετε τη φόρμα...',
      cta: 'Αποθήκευση & Συνέχεια',
      skip: 'Παράλειψη',
      success: 'Η προσαρμογή αποθηκεύτηκε!',
    },
    webhook: {
      title: 'Ειδοποιήσεις Webhook',
      subtitle: 'Λάβετε ειδοποιήσεις σε πραγματικό χρόνο όταν κάποιος ολοκληρώσει τη φόρμα σας.',
      urlLabel: 'URL Webhook (προαιρετικό)',
      urlPlaceholder: 'https://your-server.com/webhook',
      cta: 'Αποθήκευση & Συνέχεια',
      ctaEmpty: 'Συνέχεια',
      skip: 'Παράλειψη',
      success: 'Το webhook ρυθμίστηκε!',
    },
    autoRetry: {
      title: 'Προγραμματισμένη Επαναπροσπάθεια',
      subtitle: 'Αν μια υποβολή αποτύχει, η αυτόματη επαναπροσπάθεια θα συνεχίσει κάθε λεπτό μέχρι να επιτύχει.',
      enable: 'Ενεργοποίηση',
      enableDesc: 'Συνιστάται',
      disable: 'Απενεργοποίηση',
      disableDesc: 'Μόνο χειροκίνητα',
      cta: 'Αποθήκευση & Τέλος',
    },
    done: {
      title: 'Είστε Έτοιμοι!',
      subtitle: 'Η φόρμα AI σας είναι έτοιμη. Μοιραστείτε το QR code ή το μοναδικό URL με το κοινό σας.',
      dashboard: 'Μετάβαση στο Dashboard',
      qrCodes: 'Διαχείριση QR Codes',
    },
    steps: ['Καλωσόρισμα', 'Δημιουργία QR', 'Προσαρμογή', 'Webhooks', 'Επαναπροσπ.', 'Τέλος'],
    back: 'Πίσω',
  },
};

export const getTranslations = (lang = 'en') => translations[lang] || translations.en;

export const detectLanguage = () => {
  const browserLang = navigator.language?.split('-')[0] || 'en';
  return translations[browserLang] ? browserLang : 'en';
};
